const VisaRefusalKeys = {
    key1: "yes",
    key2: "no",
}

export default VisaRefusalKeys;